import { Button, DialogActions } from '@mui/material';
import React, { FC } from 'react';

interface IProps {
  onCancel: () => void;
  onDone: () => void;
  isDoneDisabled: boolean;
}

const footerStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 1,
  px: 3,
  pt: 1.5,
  pb: 2,
  borderTop: '1px solid',
  borderColor: 'divider',
  flexShrink: 0,
};

export const ModalFooter: FC<IProps> = ({ onCancel, onDone, isDoneDisabled }) => (
  <DialogActions disableSpacing sx={footerStyles} data-action="template_modal_footer">
    <Button variant="text" color="primary" onClick={onCancel} data-action="cancel_btn">
      Cancel
    </Button>
    <Button variant="contained" color="primary" onClick={onDone} disabled={isDoneDisabled} data-action="done_btn">
      Done
    </Button>
  </DialogActions>
);
